import { motion } from "framer-motion";
import { Card, CardContent } from "./ui/card";
const trainers = [
  {
    name: "Rahul",
    image: "/rahul.webp",
    experience: "3+years",
  },
  {
    name: "Mukul Kumar",
    image: "/mukul.webp",
    experience: "3+ years",
  },
  {
    name: "Vamshi",
    image: "/vamshi.webp",
    experience: "3+ years",
  }
];

export const Trainers = () => {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-3xl md:text-4xl font-bold text-center text-primary mb-16"
        >
          Meet the Experts Behind the Success

        </motion.h2>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {trainers.map((trainer, index) => (
            <motion.div
              key={trainer.name}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: index * 0.1 }}
            >
              <Card className="overflow-hidden group hover:shadow-xl transition-all duration-300">
                <CardContent className="p-0">
                  <div className="relative overflow-hidden">
                    <img
                      src={trainer.image}
                      alt={trainer.name}
                      className="w-full h-64 object-cover transform group-hover:scale-110 transition-transform duration-300"
                      loading="lazy"
                    />
                  </div>
                  <div className="p-6 text-center">
                    <h3 className="text-xl font-semibold text-primary mb-2">
                      {trainer.name}
                    </h3>
                    <p className="text-accent text-sm font-medium">
                      Experience: {trainer.experience}
                    </p>
                  </div>
                </CardContent>
              </Card>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};